module.exports = __webpack_public_path__ + "static/media/HU.79de890c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/HU.svg
// module id = 273
// module chunks = 0